module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "ORIM-Chapter-Title-Page-Break--Body-",
    attrs: {
      "id": "_idParaDest-6"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor005"
    }
  }), _vm._v("CHAPTER 4")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-"
  }, [_c('img', {
    attrs: {
      "alt": "ship",
      "src": "image/ship.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Ohio Dave blew his boat up one sunny morning and burned the skin off ninety percent of his ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("body, ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("ending his around-the-world")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("adventure.")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("He")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("was")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("a")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("young")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("guy,")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("sailing")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("alone,")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("was ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("re-fitting his boat, ")]), _c('span', {
    staticClass: "ORIM-Ital CharOverride-5"
  }, [_vm._v("Plumbelly")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v(", in ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Tongu Tongu ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("while waiting out the typhoon season like all the other cruisers. He had torn his engine apart, trying to fix something or ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("other, ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("and had accidentally filled his bilge")]), _c('span', {
    staticClass: "CharOverride-2"
  }), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("up")]), _c('span', {
    staticClass: "CharOverride-2"
  }), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("with")]), _c('span', {
    staticClass: "CharOverride-2"
  }), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("gasoline.")]), _c('span', {
    staticClass: "CharOverride-2"
  }), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("I")]), _c('span', {
    staticClass: "CharOverride-2"
  }), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("guess")]), _c('span', {
    staticClass: "CharOverride-2"
  }), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("he")]), _c('span', {
    staticClass: "CharOverride-2"
  }), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("didn’t")]), _c('span', {
    staticClass: "CharOverride-2"
  }), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("notice")]), _c('span', {
    staticClass: "CharOverride-2"
  }), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("the")]), _c('span', {
    staticClass: "CharOverride-2"
  }), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("smell")]), _c('span', {
    staticClass: "CharOverride-2"
  }), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("after")]), _c('span', {
    staticClass: "CharOverride-2"
  }), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("working on")]), _c('span', {
    staticClass: "CharOverride-2"
  }), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("the")]), _c('span', {
    staticClass: "CharOverride-2"
  }), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("engine")]), _c('span', {
    staticClass: "CharOverride-2"
  }), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("all")]), _c('span', {
    staticClass: "CharOverride-2"
  }), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("week.")]), _c('span', {
    staticClass: "CharOverride-2"
  }), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("He")]), _c('span', {
    staticClass: "CharOverride-2"
  }), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("must")]), _c('span', {
    staticClass: "CharOverride-2"
  }), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("have")]), _c('span', {
    staticClass: "CharOverride-2"
  }), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("gone")]), _c('span', {
    staticClass: "CharOverride-2"
  }), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("to")]), _c('span', {
    staticClass: "CharOverride-2"
  }), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("light")]), _c('span', {
    staticClass: "CharOverride-2"
  }), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("his")]), _c('span', {
    staticClass: "CharOverride-2"
  }), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Primus")]), _c('span', {
    staticClass: "CharOverride-2"
  }), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("stove")]), _c('span', {
    staticClass: "CharOverride-2"
  }), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("in the morning to make a cup of coffee and, BOOM, the gasoline fumes went off like a bomb.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("We ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("were having breakfast down below on ")]), _c('span', {
    staticClass: "ORIM-Ital"
  }, [_vm._v("Seminole ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("when she ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("blew.")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("explosion")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("was")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("muffled,")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("but")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("it")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("rattled")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("plates")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("on")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("table. Then David started screaming: a piercing shriek we could hear half a mile ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("away. ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("He screamed seven times and then jumped into the filthy tropical waters of ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Tongu ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Harbor and was")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("silent.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Dad and I got in the dinghy and rowed toward ")]), _c('span', {
    staticClass: "ORIM-Ital"
  }, [_vm._v("Plumbelly. ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I could see other cruisers gathering in their dinghies, hauling him out of the water and heading for shore. When we got there the boat looked the same as ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("ever, ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("except the hatches had been blown off and smoke poured")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("out")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("from")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("below.")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("main")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("hatch")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("had")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("landed")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("in")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("cockpit,")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("but the")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("forward")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("one")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("blew")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("overboard")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("was")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("drifting")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("away,")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("so")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("fetched")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("it back in the skiff. ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Tahiti ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Tom ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("rowed over from ")]), _c('span', {
    staticClass: "ORIM-Ital"
  }, [_vm._v("Chicadee ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("with a couple of fire extinguishers in his partially deflated rubber")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("dinghy.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Oh my god—did you hear that—what happened?” he said. “I always knew gas engines were bad news—poor David—he’s just a kid—a nice kid—he wanted to go home but not like this—how do we find his parents?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Hand me those extinguishers,” Dad said.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("There were still clouds of rank smoke billowing out of the openings where the hatches had been.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Will he be OK—is the hospital any good—it smells like Da Nang—oh Jesus!”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Motormouth couldn’t shut up.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Give me the goddamn extinguishers!” Dad shouted.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Dad and I each sprayed a dry-chemical extinguisher down through the open hatchways, and then we covered the blown-off hatches to stop the flow of oxygen to the smoldering woodwork below. There wasn’t much else we could do.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Three days later, Ohio Dave died of kidney failure at the Lyndon B. Johnson Tropical Medical Center in Bu’ulita and ")]), _c('span', {
    staticClass: "ORIM-Ital"
  }, [_vm._v("Plumbelly ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("sat quiet")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("alone,")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("afternoon")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("rains")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("washing")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("soot")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("from")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("her")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("decks.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("A week later, Lloyd and I paddled out to ")]), _c('span', {
    staticClass: "ORIM-Ital"
  }, [_vm._v("Plumbelly ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("in the tin canoe.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I heard his parents are flying out here to get him,” I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I wonder if they’ll get a discount on the cremation.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“What’re you talking about?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“You know, the job’s already half done.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Lloyd hooted and slapped the side of the canoe. I stopped paddling and turned.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“You didn’t hear him screaming.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("He rested his paddle across his knees.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I guess it’s not that funny,” he said.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“It was worse than listening to you when your dad’s beating you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Lloyd looked up at me from under the brim of his pith helmet, his blue eyes opaque. He made a few desultory strokes with his paddle.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Why’d you have to bring that up?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I just can’t get the screaming out of my head,” I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("\t“One of these days I am going to kill him.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The canoe bobbed quietly. Water dripped from our resting paddles.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I know the feeling,” I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("We")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("pulled")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("up")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("alongside")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "ORIM-Ital"
  }, [_vm._v("Plumbelly")]), _c('span', {
    staticClass: "ORIM-Ital"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("climbed")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("aboard,")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("letting")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the canoe trail astern. ")]), _c('span', {
    staticClass: "ORIM-Ital"
  }, [_vm._v("Plumbelly ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("was a small “island” boat, built by hand on")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("beach")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("in")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("West")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Indies.")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("She")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("was")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("about")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("twenty-eight")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("feet")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("long, double-ended, gaff-rigged, flush-decked, and a tough-looking little boat.")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Her")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("sails")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("were")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("still")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("neatly")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("furled")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("under")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("their")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("covers,")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the halyards and sheets coiled and hung from their belaying pins. There was a coffee mug in the cockpit and a pair of binoculars sitting next to it. Other than the splintered hatches, ")]), _c('span', {
    staticClass: "ORIM-Ital"
  }, [_vm._v("Plumbelly ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("looked ready to go to sea, but she smelled like the ashes of a cold campfire.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Lloyd and I ventured ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("below, ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("holding our t-shirts over our noses. Everything was singed, melted, or half-burned, the paint and varnish blistered. The heat had charred a lot of the woodwork, but the detonation")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("had")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("also")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("burned")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("all")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("oxygen")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("in")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("cabin")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("blown")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("out the fire, so only David’s clothes and books had continued to")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("smolder.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Cool. Look.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Lloyd")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("held")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("up")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("a")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("slightly")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("burnt")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "ORIM-Ital"
  }, [_vm._v("Penthouse")]), _c('span', {
    staticClass: "ORIM-Ital"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("magazine")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("we")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("flipped through it, entranced by the images of naked women in apparent ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("ecstasy.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Why do they all look like it hurts?” Lloyd said.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I didn’t answer. I hadn’t seen a ")]), _c('span', {
    staticClass: "ORIM-Ital"
  }, [_vm._v("Penthouse ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("since my father had forced Armin and me to look at one when I was twelve.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Lloyd snapped his fingers in front of my eyes.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Aha!” ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("he said, “Now I know how to hypnotize")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("He slowly waved the burnt magazine back and forth.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Relax. You are under my power,” he said.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I batted the magazine away, suddenly aware of the close stench of the charred wreckage around me, and ran up the companionway ladder. Lloyd followed. On deck, the relentless sunshine was tempered by a cool sea breeze, wafting the familiar odors of Tongu Harbor: decaying fish, diesel fuel and the hint of pork roasting in an ")]), _c('span', {
    staticClass: "ORIM-Ital"
  }, [_vm._v("umu ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("somewhere to windward.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Are you thinking what I’m thinking?” Lloyd asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I’m thinking a lot of things.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“About this boat, I mean. We could fix it up.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“You’re dreaming, man. We shouldn’t even be on board.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Nobody cares.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“His parents might.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I bet they wish she’d disappear.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I looked up at the masthead where a slender red pennant fluttered. The rigging was taut and tarred black, the mast gleaming with grease.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Tonga’s not that far away,” I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Now you’re talking.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Talking crazy.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Lloyd lit a cigarette and we stared in silence out across the water toward the mouth of the harbor. ")]), _c('span', {
    staticClass: "ORIM-Ital"
  }, [_vm._v("Plumbelly ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("tugged at her mooring.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“She needs a lot of work,” I said. “You can’t just put to sea in anything.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("He took off his pith helmet and spun it slowly around his finger.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Do you really think she’s just anything?” he said.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I looked at the curve of the oak tiller, the heavy main sheet blocks coated with linseed oil. I imagined the stern lifting to a following sea, the rush of water alongside. She was small, to be sure, but she would be steady on the helm, and buoyant, and her rig was big enough to carry her through light airs and heavy enough to take a gale.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“No,” I said, “she’s definitely something.”")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6dbd9374","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Plumbelly6.vue
// module id = 81
// module chunks = 0